import React, { useCallback, useMemo, useState, useEffect } from "react";
import { Box, TextField, Typography, Button } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import { useFormik } from "formik";
import ConfigDetail from "./AndroidConfig/ConfigDetail";
import styles from "./index.module.less";
import HasPermission from "@/components/commons/HasPermission";
import DeviceGroupsModal from "@/components/FormFields/DeviceGroups/DeviceGroupsModal";
import AppConfig, {
  initValues as appConfigInitValues
} from "./AndroidConfig/AppConfig";
import AppBlockList, {
  initValues as appBlockListInitValues
} from "./AndroidConfig/AppBlockList";
import AppWhiteBlockList, {
  initValues as appWhiteBlockListInitValues
} from "./AndroidConfig/AppWhiteBlockList";
import SystemConfig, {
  initValues as systemConfigInitValues
} from "./AndroidConfig/SystemConfig";
import WifiConfig, {
  initValues as wifiConfigInitValues
} from "./AndroidConfig/WifiConfig";
import DeployFiles, {
  initValues as deployFilesInitValues
} from "./AndroidConfig/DeployFiles";
import WallPaperSetting, {
  initValues as wallPaperSettingInitValues,
  wallPaperSettingName
} from "./AndroidConfig/WallPaper";
import SystemControl, {
  initValues as systemControlInitValues,
  systemControlName
} from "./AndroidConfig/SystemControl";
import {
  addProfileConfig,
  getProfileConfigHistoryInfo,
  getProfileConfigInfo,
  updateProfileConfig
} from "@/apis/apiCollection";
import { useHistory } from "react-router-dom";
import { toast } from "@/apis/request";

export function setValueWithDefault(objStr, defaultValue) {
  return objStr ? JSON.parse(objStr) : defaultValue;
}

const TemplateForm = ({ readOnly, id, isHistory }) => {
  const { t, userLanguage } = useTranslation();
  const history = useHistory();
  const initialValues = useMemo(() => {
    return {
      templateName: "",
      groupIds: ["d954f779-2e2a-4991-8738-f6bfc9e43a16"],
      configDetail: {},
      application: appConfigInitValues,
      systemSetting: systemConfigInitValues,
      wifi: wifiConfigInitValues,
      fileSynchronization: deployFilesInitValues,
      applicationBlacklist: appBlockListInitValues,
      applicationWhitelist: appWhiteBlockListInitValues,
      [wallPaperSettingName]: wallPaperSettingInitValues,
      [systemControlName]: systemControlInitValues
    };
  }, []);
  const routes = useMemo(
    () => [
      [t({ defaultMessage: "配置文件详情" }), ConfigDetail, "configDetail"],
      [t({ defaultMessage: "应用管理" }), AppConfig, "application"],
      [t({ defaultMessage: "系统设置" }), SystemConfig, "systemSetting"],
      [t({ defaultMessage: "Wi-Fi" }), WifiConfig, "wifi"],
      [t({ defaultMessage: "文件同步" }), DeployFiles, "fileSynchronization"],
      [t({ defaultMessage: "黑名单" }), AppBlockList, "applicationBlacklist"],
      [t({ defaultMessage: "白名单" }), AppWhiteBlockList, "applicationWhitelist"],
      [
        t({ defaultMessage: "壁纸配置" }),
        WallPaperSetting,
        wallPaperSettingName
      ],
      [t({ defaultMessage: "功能控制" }), SystemControl, systemControlName]
    ],
    [userLanguage]
  );
  const { values, setValues, handleChange, handleSubmit, handleReset, setFieldValue } =
    useFormik({
      initialValues,
      onSubmit: () => {
        // handleReloadDataTable();
      }
    });
  const [chosenConfigIndex, setChosenConfigIndex] = useState(0);
  const SelectedConfig = routes[chosenConfigIndex][1];
  const SelectedConfigData = values[routes[chosenConfigIndex][2]];

  const [groupsModalOpen, setGroupsModalOpen] = useState(false);
  const handleGroupsConfirm = useCallback(
    (ids, details) => {
      handleChange({ target: { name: "groupIds", value: ids } });
      setGroupsModalOpen(false);
    },
    [handleChange]
  );

  const handleGroupsClose = useCallback(() => {
    setGroupsModalOpen(false);
  }, []);

  const handleSaveDraft = useCallback(async () => {
    if (
      !values.templateName ||
      (values.templateName &&
        values.templateName.trim &&
        !values.templateName.trim())
    ) {
      toast.error(t({ defaultMessage: "未填写模板名称" }));
      return;
    }
    // prettier-ignore
    // if (
    //   values.fileSynchronization.configs.reduce((acc, cur) => acc + cur.files.length, 0) > 10
    // ) {
    //   toast.error(t({ defaultMessage: "文件同步最多允许添加10个文件" }));
    //   return;
    // }
    if (values.wifi && values.wifi.open) {
      if (!values.wifi.wifis.length) {
        setChosenConfigIndex(3);
        toast.error(t({ defaultMessage: "请填写wifi配置" }));
        return;
      }
      if (values.wifi.wifis.some(wifi => !wifi.ssid || !wifi.password)) {
        setChosenConfigIndex(3);
        toast.error(t({ defaultMessage: "wifi配置填写不全" }));
        return;
      }
    }
    const params = {
      name: values.templateName,
      osType: "android",
      application: JSON.stringify(values.application),
      systemSetting: JSON.stringify(values.systemSetting),
      [wallPaperSettingName]: JSON.stringify(values[wallPaperSettingName]),
      [systemControlName]: JSON.stringify(values[systemControlName]),
      wifi: JSON.stringify(values.wifi),
      fileSynchronization: JSON.stringify(values.fileSynchronization),
      applicationBlacklist: JSON.stringify(values.applicationBlacklist),
      applicationWhitelist: JSON.stringify(values.applicationWhitelist)
    };
    routes
      .filter(route => route[2] !== "configDetail")
      .forEach(route => {
        const name = route[2];
        params[name] = JSON.stringify(values[name]);
      });
    if (id) {
      await updateProfileConfig({
        configId: id,
        ...params
      });
    } else {
      await addProfileConfig(params);
    }
    history.push("/profile-config/template");
    toast.success(t({ defaultMessage: "保存成功" }));
  }, [values, id]);

  useEffect(() => {
    if (id) {
      const handleData = res => {
        // if (blackList.enableWhiteList === undefined) blackList.enableWhiteList = false
        // res.applicationBlacklist = JSON.stringify(blackList)
        setValues({
          templateName: res.name,
          configDetail: {
            status: res.status,
            version: res.version,
            person: res.updateUserName || res.createUserName,
            lastUpdateTime: Number(res.updatedAt)
          },
          application: setValueWithDefault(
            res.application,
            appConfigInitValues
          ),
          systemSetting: setValueWithDefault(
            res.systemSetting,
            systemConfigInitValues
          ),
          wifi: setValueWithDefault(res.wifi, wifiConfigInitValues),
          fileSynchronization: setValueWithDefault(
            res.fileSynchronization,
            deployFilesInitValues
          ),
          applicationBlacklist: setValueWithDefault(
            res.applicationBlacklist,
            appBlockListInitValues
          ),
          applicationWhitelist: setValueWithDefault(
            res.applicationWhitelist,
            appWhiteBlockListInitValues
          ),
          [systemControlName]: setValueWithDefault(
            res[systemControlName],
            systemControlInitValues
          ),
          [wallPaperSettingName]: setValueWithDefault(
            res[wallPaperSettingName],
            wallPaperSettingInitValues
          )
        });
      };
      if (isHistory)
        getProfileConfigHistoryInfo({ configHistoryId: id }).then(handleData);
      else getProfileConfigInfo({ configId: id }).then(handleData);
    }
  }, [id]);

  return (
    <form
      onSubmit={handleSubmit}
      style={{ display: "flex", flexDirection: "column", flex: 1 }}
    >
      <Box display="flex" alignItems="center">
        {isHistory ? (
          <Typography variant="h4">{values.templateName}</Typography>
        ) : (
          <>
            <Typography variant="h6" style={{ marginRight: 8 }}>
              {t({ defaultMessage: "模板名称：" })}
            </Typography>
            <TextField
              variant="outlined"
              name="templateName"
              onChange={readOnly ? () => { } : handleChange}
              style={{ width: 512, background: "#fff" }}
              value={values.templateName}
              size="small"
              inputProps={{ maxLength: 30 }}
            // readOnly={readOnly}
            // readOnly
            // disabled={readOnly}
            />
          </>
        )}
        <Box marginLeft="auto">
          {!readOnly && (
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: 8, minWidth: 118 }}
              onClick={handleSaveDraft}
            >
              {t({ defaultMessage: "保存" })}
            </Button>
          )}
          {readOnly && (
            <HasPermission permission="profile_template_edit">
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: 8, minWidth: 118 }}
                onClick={() => history.push(`/profile-config/edit-template-android/${id}`)}
              >
                {t({ defaultMessage: "编辑" })}
              </Button>
            </HasPermission>
          )}
          {/*<Button*/}
          {/*  variant="contained"*/}
          {/*  color="primary"*/}
          {/*  type="submit"*/}
          {/*  style={{ marginRight: 8, minWidth: 118 }}*/}
          {/*  onClick={() => setGroupsModalOpen(true)}*/}
          {/*>*/}
          {/*  {t({ defaultMessage: "关联门店" })}*/}
          {/*</Button>*/}
          {/* {!readOnly && ( */}
          <Button
            variant="outlined"
            color="primary"
            type="submit"
            style={{ marginRight: 8, minWidth: 118 }}
            onClick={() => history.push("/profile-config/template")}
          >
            {t({ defaultMessage: "取消" })}
          </Button>
          {/* )} */}
        </Box>
      </Box>
      <Box display="flex" flex={1} marginTop={3}>
        <Box
          display="flex"
          flexDirection="column"
          width={240}
          padding="22px 16px"
          sx={containerSx}
        >
          {routes.map((route, ind) => {
            const [name] = route;
            return (
              <div
                className={`${styles.templateName} ${ind === chosenConfigIndex ? styles.chosenTemplate : ""
                  }`}
                onClick={() => setChosenConfigIndex(ind)}
                key={name}
              >
                {name}
              </div>
            );
          })}
        </Box>
        <Box
          display="flex"
          flex={1}
          marginLeft={3}
          padding="32px"
          sx={containerSx}
        >
          <SelectedConfig
            values={SelectedConfigData}
            onChange={readOnly ? () => { } : handleChange}
            readOnly={readOnly}
            isHistory={isHistory}
            setFieldValue={setFieldValue}
          />
        </Box>
      </Box>
      <DeviceGroupsModal
        open={groupsModalOpen}
        checkedKeys={values.groupIds}
        checkStrictly
        onClose={handleGroupsClose}
        onConfirm={handleGroupsConfirm}
      />
    </form>
  );
};

const containerSx = {
  bgcolor: "#fff",
  borderRadius: 16
};

export default TemplateForm;
